import {
  Component,
} from "@angular/core";
import {GlobalStorageService} from "../../services/global-storage.service";
import {UtilsService} from "../../services/utils.service";

@Component({
  selector: 'app-top-toolbar',
  templateUrl: './top-toolbar.component.html',
  styleUrls: ['./top-toolbar.component.scss'],
  standalone: false
})

export class TopToolbarComponent {
  constructor(public global: GlobalStorageService, private utils: UtilsService) {
  }
}
